export default function exploreFilters(state = {
  teamIds: null,
}, action) {
  switch (action) {
  default:
    return state;
  }
}
